export const EVENT_IMAGES = [
  '/images/event/card-1.webp',
  '/images/event/card-2.webp',
  '/images/event/card-3.webp',
  '/images/event/card-4.webp',
];

export const AUTO_SLIDE_INTERVAL = 3000; // 3 seconds

// 이벤트 상세 글은 블로그(별도 Next.js 앱)에 있다. 언어 프리픽스는 렌더 시점에 붙인다.
export const EVENT_BLOG_SLUG = 'transit-lounge-yongsan-free-night-event';
